// extracted by mini-css-extract-plugin
module.exports = {"chip":"_-_-pharmacy-src-user-userDescription-invitedExpertChip__chip---jeoi"};